import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { helpScreenForPath } from '@alexiarest/shared';

interface PageHeaderProps {
  title: string;
  /** Una frase que explica para que sirve la pantalla. */
  description?: string;
  actions?: ReactNode;
}

export function PageHeader({ title, description, actions }: PageHeaderProps): JSX.Element {
  // El tour guiado espera a que la cabecera de la pantalla destino este
  // pintada; la reconoce por el id del manual (help.ts), no por el titulo.
  const pantalla = helpScreenForPath(useLocation().pathname);
  return (
    <div className="page-head" data-tour="page" data-screen={pantalla?.id}>
      <div>
        <h1 className="page-title">{title}</h1>
        {description && <p className="page-desc">{description}</p>}
      </div>
      {actions && <div className="page-actions">{actions}</div>}
    </div>
  );
}
